import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils';

const inputVariants = cva(
	'relative items-center group text-left rounded-xl transition-colors border-2 border-input focus-visible:outline-none focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-transparent placeholder:text-muted-foreground disabled:opacity-50 disabled:cursor-not-allowed w-full',
	{
		variants: {
			variant: {
				default: 'bg-background/80 text-popover-foreground hover:bg-background/80',
				primary: 'text-primary-foreground bg-primary hover:bg-primary/90',
				secondary: 'text-secondary-foreground bg-secondary hover:bg-secondary/90',
			},
			size: {
				default: 'px-4 py-2.5 h-11',
				sm: 'px-3 py-2 h-9 text-sm',
				lg: 'px-5 py-3 h-12 text-lg',
			},
		},
		defaultVariants: {
			variant: 'default',
			size: 'default',
		},
	},
);

// Input component
export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>, VariantProps<typeof inputVariants> {
	size?: 'default' | 'sm' | 'lg';
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, variant, size, ...props }, ref) => {
	return (
		<input className={cn(inputVariants({ variant, size }), className, props.disabled && 'pointer-events-none opacity-50')} ref={ref} {...props} />
	);
});
Input.displayName = 'Input';

export { Input, inputVariants };
